<template>
  <generic-modal :title="$t('central dispatch service')" ref="generic_modal">
    <div v-if="service_loaded">
      <!-- Información general -->
      <article class="message is-info mb-5">
        <div class="message-header">
          <span
            ><i class="fa fa-info-circle mr-2"></i
            >{{ $t("general information") }}</span
          >
        </div>
        <div class="message-body">
          <div class="columns is-vcentered">
            <div class="column is-7">
              <ul>
                <li>
                  <strong>{{ $t("central dispatch id") }}:</strong>
                  {{ service.central_dispatch_id }}
                </li>
                <li>
                  <strong>{{ $t("listing status") }}:</strong>
                  {{ service.central_dispatch_data.listingStatus }}
                </li>
                <li>
                  <strong>{{ $t("available date") }}:</strong>
                  {{ format_date(service.central_dispatch_data.availableDate) }}
                </li>
                <li>
                  <strong>{{ $t("expiration date") }}:</strong>
                  {{
                    format_date(service.central_dispatch_data.expirationDate)
                  }}
                </li>
                <li>
                  <strong>{{ $t("trailer type") }}:</strong>
                  {{ service.central_dispatch_data.trailerType }}
                </li>
              </ul>
            </div>
            <div class="column is-5 has-text-centered">
              <article class="message is-danger">
                <div class="message-body">
                  <ul>
                    <li>
                      <strong>{{ $t("total") }}:</strong> ${{
                        service.central_dispatch_data.price.total
                      }}
                    </li>
                    <li>
                      <strong>{{ $t("cod") }}:</strong> ${{
                        service.central_dispatch_data.price.cod.amount
                      }}
                      ({{
                        service.central_dispatch_data.price.cod.paymentMethod
                      }})
                    </li>
                    <li>
                      <strong>{{ $t("balance") }}:</strong> ${{
                        service.central_dispatch_data.price.balance.amount
                      }}
                      ({{
                        service.central_dispatch_data.price.balance
                          .balancePaymentMethod
                      }})
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </div>
      </article>

      <article class="message is-primary mb-5">
        <div class="message-header">
          <span><i class="fa fa-car mr-2"></i>{{ $t("vehicle") }}</span>
        </div>
        <div class="message-body">
          <div class="columns is-multiline">
            <div
              class="column is-6"
              v-for="vehicle in service.central_dispatch_data.vehicles"
              :key="vehicle.id"
            >
              <div class="box">
                <p>
                  <strong>{{ $t("brand") }}:</strong> {{ vehicle.make }}
                </p>
                <p>
                  <strong>{{ $t("model") }}:</strong> {{ vehicle.model }}
                </p>
                <p>
                  <strong>{{ $t("year") }}:</strong> {{ vehicle.year }}
                </p>
                <p>
                  <strong>{{ $t("additional info") }}:</strong>
                  {{ vehicle.additionalInfo }}
                </p>
              </div>
            </div>
            <div class="column is-6">
              <article class="message is-link">
                <div class="message-body">
                  <ul>
                    <li>
                      <strong>{{ $t("company") }}:</strong>
                      {{ service.central_dispatch_data.shipper.companyName }}
                    </li>
                    <li>
                      <strong>{{ $t("email") }}:</strong>
                      {{ service.central_dispatch_data.shipper.email }}
                    </li>
                    <li>
                      <strong>{{ $t("phone") }}:</strong>
                      {{ service.central_dispatch_data.shipper.phone }}
                    </li>
                    <li>
                      <strong>{{ $t("rating") }}:</strong>
                      {{
                        service.central_dispatch_data.shipper.overallRating
                          .averageRating
                      }}
                      ({{
                        service.central_dispatch_data.shipper.numberOfRatings
                      }}
                      {{ $t("ratings") }})
                    </li>
                    <li>
                      <strong>{{ $t("schedule") }}:</strong>
                      {{
                        service.central_dispatch_data.shipper.hoursOfOperation
                      }}
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </div>
      </article>

      <div class="columns mb-5">
        <div class="column">
          <article class="notification is-success is-light">
            <p class="title is-6">
              <i class="fa fa-map-marker-alt mr-2"></i>{{ $t("origin") }}
            </p>
            <p>
              {{ service.central_dispatch_data.origin.city }},
              {{ service.central_dispatch_data.origin.state }}
            </p>
            <p>
              <strong>{{ $t("zip code") }}:</strong>
              {{ service.central_dispatch_data.origin.zip }}
            </p>
          </article>
        </div>
        <div class="column">
          <article class="notification is-warning is-light">
            <p class="title is-6">
              <i class="fa fa-flag-checkered mr-2"></i>{{ $t("destination") }}
            </p>
            <p>
              {{ service.central_dispatch_data.destination.city }},
              {{ service.central_dispatch_data.destination.state }}
            </p>
            <p>
              <strong>{{ $t("zip code") }}:</strong>
              {{ service.central_dispatch_data.destination.zip }}
            </p>
          </article>
        </div>
      </div>
    </div>

    <!-- <pre>{{ service }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  format_date,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CentralDispatchServiceModal",
  components: { GenericModal },
  data() {
    return {
      service: null,
      service_loaded: false,
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show(service_uuid) {
      let v = this;
      v.set_initial_state();

      get("/central-dispatch-tracker/my-tasks", { uuid: service_uuid })
        .then((element) => {
          v.service = element;
          v.service_loaded = true;
          v.error = "";
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    set_initial_state() {
      let v = this;
      v.service = null;
      v.error = "";
      v.service_loaded = false;
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
